module.exports = __webpack_public_path__ + "img/img-8.fd2e00ee.svg";